/**
 * 文档信息维护
 */
import React, { Component } from 'react';
import { Modal, Form, Row, Col, Input } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import EditorContent from '../../ui/EditorContent'
import validator from '../../../util/validator';

const fields = [{
    "text": "编码",
    "field": "code",
    rules: [
        { required: true, message: '编码不能为空!' },
        { max: 64, message: '编码不能超过64个字符！' },
        validator.lineEn
    ]
}, {
    "text": "名称",
    "field": "name",
    rules: [
        { required: true, message: '文件名称不能为空!' },
        { max: 64, message: '文件名称不能超过64个字符！' },
    ]
}, {
    "text": "内容",
    "field": "content",
    textarea: true,
}];

class DocumentEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id;
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["content"] = this.getValue();
            http.post({
                url: '/document/save',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    getValueRef = (getValue) => {
        this.getValue = getValue;
    }

    createDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = (<Row key={i}>
                <Col span={24}>
                    {this.createDomItem(data[i])}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    };

    createDomItem = (item) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let content = editData.content;
        let domItem = "";
        domItem = (
            <Form.Item label={item.text + "："} labelCol={{ span: 3 }} wrapperCol={{ span: 21 }}>
                {getFieldDecorator(item.field, {
                    rules: item.rules,
                    initialValue:
                        item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                            : editData[item.field],
                    valuePropName: item.radio ? 'checked' : 'value',
                })(
                    item.textarea ? <EditorContent editDataContent={content} getValueRef={this.getValueRef} editorFlag={this.props.visible} />
                        : <Input />
                )}
            </Form.Item>
        );
        return domItem;

    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={1000}
                visible={visible}
                title="文档信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" className="ant-notice-modal" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const DocumentEdit = Form.create()(DocumentEditForm);

export default DocumentEdit;